"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImagePlacementOrder = void 0;
const imagePlacementOrderMap = new Map([
    ["above-chapter-no", 1],
    ["above-chapter-title", 2],
    ["below-chapter-title", 3],
]);
const defaultPlacement = 4;
const getImagePlacementOrder = (placement) => {
    return placement ? (imagePlacementOrderMap.get(placement) || defaultPlacement) : defaultPlacement;
};
exports.getImagePlacementOrder = getImagePlacementOrder;
